import { FundManager, Trustee } from './api-types';

export const GET_FUNDS_LIST = 'GET_FUNDS_LIST';
export const GET_FUNDS_LIST_SUCCESS = 'GET_FUNDS_LIST_SUCCESS';

export const ADD_FUND = 'ADD_FUND';
export const ADD_FUND_SUCCESS = 'ADD_FUND_SUCCESS';

export const UPLOAD_BULK_FUND_SUCCESS = 'UPLOAD_BULK_FUND_SUCCESS';
export const UPLOAD_BULK_FUND = 'UPLOAD_BULK_FUND';

export const ADD_PLAN = 'ADD_PLAN';
export const ADD_PLAN_SUCCESS = 'ADD_PLAN_SUCCESS';

export const UPDATE_PLAN = 'UPDATE_PLAN';
export const UPDATE_PLAN_SUCCESS = 'UPDATE_PLAN_SUCCESS';

export const GET_FUNDS_ACCESS = 'GET_FUNDS_ACCESS';
export const GET_FUNDS_ACCESS_SUCCESS = 'GET_FUNDS_ACCESS_SUCCESS';

export const UPDATE_FUND = 'UPDATE_FUND';
export const UPDATE_FUND_SUCCESS = 'UPDATE_FUND_SUCCESS';

export const GET_PLAN = 'GET_PLAN';
export const GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS';

export const GET_PLAN_DETAILS = 'GET_PLAN_DETAILS';
export const GET_PLAN_DETAILS_SUCCESS = 'GET_PLAN_DETAILS_SUCCESS';

export type GetFundsListResponseBody = {
  funds: FundProps[];
};

export type InvestmentModesProp = {
  percentage: string;
  months?: string;
};
export type SipInvestmentModeProp = InvestmentModesProp & { sno: number };

export type FundProps = {
  amcId: number;
  schemeCode: string;
  schemeName: string;
  schemeShortName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  bankAccountNumber: string;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  plans: ClassPlanProps[];
  id: string;
  LEEGALITY_STAMP_SERIES: string;
  LEEGALITY_STAMP_SERIES_GROUP: string;
  LEEGALITY_STAMP_VALUE: number | null;
  LEEGALITY_USE_STAMP_SERIES: boolean | null;
  modeOfInvestment: string[] | null;
  lumpsumDetails: InvestmentModesProp | null;
  sipDetails: SipInvestmentModeProp[] | null;
  drawdownDetails: InvestmentModesProp | null;
  isOnlyXalt: boolean;
  [key: string]:
    | string
    | string[]
    | InvestmentModesProp
    | SipInvestmentModeProp[]
    | number
    | boolean
    | ClassPlanProps[]
    | undefined
    | null;
};

export type accessType = {
  fundSetupAccess: boolean;
};

export type addFundType = {
  bankAccountNumber: string;
  schemeCode: string;
  schemeName: string;
  schemeShortName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  LEEGALITY_STAMP_SERIES: string;
  LEEGALITY_STAMP_SERIES_GROUP: string;
  LEEGALITY_STAMP_VALUE: number | null;
  LEEGALITY_USE_STAMP_SERIES: boolean | null;
  modeOfInvestment: string[] | null;
  lumpsumDetails: InvestmentModesProp | null;
  sipDetails: SipInvestmentModeProp[] | null;
  drawdownDetails: InvestmentModesProp | null;
  isOnlyXalt: boolean;
};

export type topUpPlanType = {
  isTopupApplicable: boolean;
  topUpSetupFeeApplicable: string;
  topUpSetupFeeType: string | null;
  topUpMaxSetupFee: number | null;
  topUpMinSetupFee: number | null;
  topUpSetupFee: number | null;
  topUpMinCommitmentAmount: number | null;
  topUpMaxCommitmentAmount: number | null;
  topUpMinContributionPercentage: number | null;
  topUpAccreditedInvestorApplicable: string;
  topUpAccreditedMinCommitmentAmount: number | null;
  topUpManagementFeeApplicable: string;
  topUpManagementFeeType: string | null;
  topUpMinManagementFee: number | null;
  topUpMaxManagementFee: number | null;
  defaultTopUpManagementFee: number | null;
  topUpHurdleRateApplicable: string;
  topUpHurdleRateType: string | null;
  defaultTopUpHurdleRate: number | null;
  topUpMinHurdleRate: number | null;
  topUpMaxHurdleRate: number | null;
  topUpPerformanceFeeApplicable: string;
  topUpPerformanceFeeType: string | null;
  defaultTopUpPerformanceFee: number | null;
  topUpMinPerformanceFee: number | null;
  topUpMaxPerformanceFee: number | null;
  topUpExitChargeApplicable: string;
  topUpExitChargeType: string | null;
  defaultTopUpExitCharge: number | null;
  topUpMinExitCharge: number | null;
  topUpMaxExitCharge: number | null;
  topupExitChargeApplicableTill: string | null;
  topupMinInvestmentAmt: number | null;
  topUpPlacementFeeApplicable: string;
  topUpPlacementFeeType: string | null;
  topUpMaxPlacementFee: number | null;
  topUpMinPlacementFee: number | null;
  defaultTopUpPlacementFee: number | null;
  topUpOperatingExpenseApplicable: string;
  topUpOperatingExpenseType: string | null;
  topUpMaxOperatingExpense: number | null;
  topUpMinOperatingExpense: number | null;
  defaultTopUpOperatingExpenses: number | null;
};

export type addPlanType = topUpPlanType & {
  schemeId: number | string | null;
  planCode: string;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  currency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  isActive: boolean;
  custodian: string;
  setupFee: number | null;
  fundManagerId: number | null;
  trusteeId: number | null;
  planClass: number | null;
  minCommitmentAmount: number | null;
  maxCommitmentAmount: number | null;
  minInvestmentAmt: number | null;
  minContributionPercentage: number | null;
  managementFee: number | null;
  tcLink: string;
  classOfUnits: string;
  isApplicableForDirect: boolean | null;
  isApplicableForDistributor: boolean | null;
  hurdleRateApplicable: string;
  hurdleRateType: string | null;
  defaultHurdleRate: number | null;
  minHurdleRate: number | null;
  maxHurdleRate: number | null;
  performanceFeeApplicable: string;
  performanceFeeType: string | null;
  defaultPerformanceFee: number | null;
  minPerformanceFee: number | null;
  maxPerformanceFee: number | null;
  transactionCurrency: string;
  addReturnSplitApplicable: string;
  addReturnSplitType: string | null;
  defaultAddReturnSplit: string | null;
  minAddReturnSplit: number | null;
  maxAddReturnSplit: number | null;
  accreditedInvestorApplicable: string;
  accreditedMinCommitmentAmount: number | null;
  parentShareClass: string;
};

export type addFundPlanType = topUpPlanType & {
  schemeCode: string;
  schemeName: string;
  schemeShortName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  bankAccountNumber: string;
  id: string;
  schemeId: number | null;
  planCode: string;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  currency: string;
  transactionCurrency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  isActive: boolean;
  custodian: string;
  setupFee: number | null;
  fundManagerId: number | null;
  trusteeId: number | null;
  planClass: number | null;
  minCommitmentAmount: number | null;
  maxCommitmentAmount: number | null;
  minInvestmentAmt: number | null;
  minContributionPercentage: number | null;
  managementFee: number | null;
  tcLink: string;
  LEEGALITY_STAMP_SERIES: string;
  LEEGALITY_STAMP_SERIES_GROUP: string;
  LEEGALITY_STAMP_VALUE: number | null;
  LEEGALITY_USE_STAMP_SERIES: boolean | null;
  modeOfInvestment: string[] | null;
  lumpsumDetails: InvestmentModesProp | null;
  sipDetails: SipInvestmentModeProp[] | null;
  drawdownDetails: InvestmentModesProp | null;
  classOfUnits: string;
  isApplicableForDirect: boolean | null;
  isApplicableForDistributor: boolean | null;
  hurdleRateApplicable: string;
  hurdleRateType: string | null;
  defaultHurdleRate: number | null;
  minHurdleRate: number | null;
  maxHurdleRate: number | null;
  performanceFeeApplicable: string;
  performanceFeeType: string | null;
  defaultPerformanceFee: number | null;
  minPerformanceFee: number | null;
  maxPerformanceFee: number | null;
  addReturnSplitApplicable: string;
  addReturnSplitType: string | null;
  defaultAddReturnSplit: string | null;
  minAddReturnSplit: number | null;
  maxAddReturnSplit: number | null;
  accreditedInvestorApplicable: string;
  accreditedMinCommitmentAmount: number | null;
  parentShareClass: string;
  isOnlyXalt: boolean;
};

export type ClassPlanProps = topUpPlanType & {
  id: string;
  schemeId: any;
  planCode: string;
  fundManagerId: number | null;
  trusteeId: number | null;
  planClass: number | null;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  fundManager: FundManager;
  trustee: Trustee;
  currency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  custodian: string;
  setupFee: number | null;
  minCommitmentAmount: number;
  maxCommitmentAmount: number;
  minInvestmentAmt: number | null;
  minContributionPercentage: number;
  managementFee: number | null;
  isActive: boolean;
  tcLink: string;
  createdBy: number | null;
  createdAt: string;
  updatedAt: string;
  classOfUnits: string;
  isApplicableForDirect: boolean | null;
  isApplicableForDistributor: boolean | null;
  hurdleRateApplicable: string;
  hurdleRateType: string | null;
  defaultHurdleRate: number | null;
  minHurdleRate: number | null;
  maxHurdleRate: number | null;
  performanceFeeApplicable: string;
  performanceFeeType: string | null;
  defaultPerformanceFee: number | null;
  minPerformanceFee: number | null;
  maxPerformanceFee: number | null;
  transactionCurrency: string;
  addReturnSplitApplicable: string;
  addReturnSplitType: string;
  defaultAddReturnSplit: string;
  minAddReturnSplit: number | null;
  maxAddReturnSplit: number | null;
  accreditedInvestorApplicable: string;
  accreditedMinCommitmentAmount: number | null;
  parentShareClass: string;
};

export const GET_FUNDS_SUCCESS = 'GET_FUNDS_SUCCESS';
export const GET_FUNDS = 'GET_FUNDS';

export const GET_DIRECTAPPLICABLEFUNDS_SUCCESS = 'GET_DIRECTAPPLICABLEFUNDS_SUCCESS';
export const GET_DIRECTAPPLICABLEFUNDS = 'GET_DIRECTAPPLICABLEFUNDS';

export const EXPORT_FUNDS_SUCCESS = 'EXPORT_FUNDS_SUCCESS';
export const EXPORT_FUNDS = 'EXPORT_FUNDS';
